// extracted by mini-css-extract-plugin
export var darkVariantTag = "Tags-module--dark-variant-tag--d7ad3";
export var lightVariantTag = "Tags-module--light-variant-tag--c942f";
export var tag = "Tags-module--tag--4a707";
export var tagWrapper = "Tags-module--tag-wrapper--36a57";
export var tagsList = "Tags-module--tags-list--076b3";
export var tagsListContainer = "Tags-module--tags-list-container--a691b";
export var wrapContainer = "Tags-module--wrap-container--6e4ec";